import setupConsent from "./setupConsent";
import scriptLoader from "./scriptLoader";

const ensurePageSetup = ({
  scriptSrc,
  fetchMarginPercent,
  renderMarginPercent,
  mobileMarginScaling
}) => {
  if (window.googletag === undefined) {
    window.googletag = {
      cmd: [
        () => {
          window.googletag
            .pubads()
            .setForceSafeFrame(true)
            .collapseEmptyDivs(true);
          window.googletag.pubads().enableLazyLoad({
            fetchMarginPercent,
            renderMarginPercent,
            mobileScaling: mobileMarginScaling
          });
          setupConsent();
        }
      ]
    };
    scriptLoader({ scriptSrc });
  }
};

export default ensurePageSetup;
